import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':subCategoryId'}/charts`;

export const ROUTE: RouteDefinition = `${baseRoute}/:subCategoryId/charts`;

export const URL = (subCategoryId: number): RouteDefinition => `${baseRoute}/${subCategoryId}/charts`;
